export const clinicService = {
    get
};

function get(location_friendly_id){
    let header = {
        'Content-Type': 'application/json'
    }
    const requestOptions = {
        method: 'GET',
        headers: {...header},
    };

    return fetch(`${process.env.REACT_APP_API_URL}locations/${location_friendly_id}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        }).catch(function(error) {
            console.log('There has been a problem with your fetch operation: ',
            error.message);
        });;
}

function handleResponse(response) {
    if(!response.ok){
        if(response.status === 404){
            window.location.replace("/search-book/404");
        }else{
            var error = (response && response.message) || response.statusText;
            if(error.length === 0){
                error = 'Internal Server Error'
            }
            return Promise.reject(error);
        }
    }

    return response.json();
}